import { ChangeDetectionStrategy, Component, computed, Signal, WritableSignal } from '@angular/core';
import { Roles } from 'Core/enums';
import { User } from 'Core/models';
import { shellRoutes } from 'Core/routes';
import { AuthenticationService, CurrentUserStateService } from 'Core/services';

type UserRoleKind = 'admin' | 'supplier' | 'installer';

@Component({
  selector: 'app-session-dropdown',
  templateUrl: './session-dropdown.component.html',
  styleUrls: ['./session-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SessionDropdownComponent {
  public readonly userSignal: WritableSignal<User | null> = this.currentUserStateService.user;
  public readonly userRoleKind: Signal<UserRoleKind | null> = computed(() => {
    const roles = this.userSignal()?.collectionRoles ?? [];

    if (roles.includes(Roles.ROLE_ADMIN)) {
      return 'admin';
    }

    if (roles.includes(Roles.ROLE_SUPPLIER)) {
      return 'supplier';
    }

    return roles.length ? 'installer' : null;
  });
  public readonly userRoleLabel: Signal<string> = computed(() => {
    switch (this.userRoleKind()) {
      case 'admin':
        return 'Админ';
      case 'supplier':
        return 'Поставщик';
      case 'installer':
        return 'Монтажник';
      default:
        return '';
    }
  });
  shellRoutes = shellRoutes;

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly currentUserStateService: CurrentUserStateService
  ) {}

  public logout(): void {
    this.authenticationService.logout().subscribe();
  }
}
